const formatRelativeLocale = {
  lastWeek: "'noong nakaraang' eeee 'ng' p",
  yesterday: "'kahapon ng' p",
  today: "'ngayong ng' p",
  tomorrow: "'bukas ng' p",
  nextWeek: "'susunod na' eeee 'ng' p",
  other: 'P',
};

export function formatRelative(token: keyof typeof formatRelativeLocale): string {
  return formatRelativeLocale[token];
}
